import React, { useState } from 'react';
import './Testing.css';

const Testing = ({ setCurrentPage, setActiveSection }) => {
  const [activeVideo, setActiveVideo] = useState(0);
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);

  // Video paths for hosting
  const VIDEO_BASE_PATH = `${process.env.PUBLIC_URL}/videos`;

  /** Shared first-frame thumbnail (Compressive Test intro). All playlist cards display this. */
  const SHARED_THUMBNAIL_VIDEO_SRC = `${VIDEO_BASE_PATH}/COMPRESSIVE TEST.mp4`;
  const SHARED_THUMBNAIL_POSTER =
    `${process.env.PUBLIC_URL}/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/COMPRESSIVE TEST OF CONCRETE CYLINDER/comp1.jpg`;

  const testingVideos = [
    {
      id: 1,
      title: "Compressive Test",
      description: "Material strength testing for concrete samples",
      videoSrc: `${VIDEO_BASE_PATH}/COMPRESSIVE TEST.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/COMPRESSIVE TEST OF CONCRETE CYLINDER/comp1.jpg"
    },
    {
      id: 2,
      title: "DFT Testing",
      description: "Dry Film Thickness measurement for coating analysis",
      videoSrc: `${VIDEO_BASE_PATH}/DFT.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/DYE PENETRANT TESTING/DP1.jpg"
    },
    {
      id: 3,
      title: "Jet Grouting",
      description: "Ground improvement technique for soil stabilization",
      videoSrc: `${VIDEO_BASE_PATH}/JET GROUT.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/FIELD DENSITY TEST/EDG METHOD/datem/ED1.jpg"
    },
    {
      id: 4,
      title: "Magnetic Particles Test",
      description: "Non-destructive testing for surface and near-surface defects",
      videoSrc: `${VIDEO_BASE_PATH}/MAGNETIC PARTICLES TEST.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/DYE PENETRANT TESTING/379670430_1501566497277137_4548088758625246384_n.jpg"
    },
    {
      id: 5,
      title: "Penetrant Test",
      description: "Surface crack and defect detection using dye penetrant",
      videoSrc: `${VIDEO_BASE_PATH}/PENETRANT TEST.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/DYE PENETRANT TESTING/DP1.jpg"
    },
    {
      id: 6,
      title: "Plate Load Test",
      description: "In-situ testing for soil bearing capacity",
      videoSrc: `${VIDEO_BASE_PATH}/Plate Load Test.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/PLATE LOAD TESTING/PNR/370228945_1726866284480604_3536532835142410147_n.jpg"
    },
    {
      id: 7,
      title: "Pull-Out Test",
      description: "Testing the strength of concrete anchors and fixings",
      videoSrc: `${VIDEO_BASE_PATH}/Pull-Out Test.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/PULL OUT TESTING/PO1.jpg"
    },
    {
      id: 8,
      title: "Ultrasonic Flaw Detection",
      description: "Advanced NDT for internal defect detection",
      videoSrc: `${VIDEO_BASE_PATH}/ULTRASONIC FLAW DETECT 2.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/ULTRASONIC PULSE VELOCITY TEST/UP1.jpg"
    },
    {
      id: 9,
      title: "Ultrasonic Pulse Velocity",
      description: "Concrete quality and uniformity assessment",
      videoSrc: `${VIDEO_BASE_PATH}/ULTRASONIC PULSE VELOCITY TEST (NDT).mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/ULTRASONIC PULSE VELOCITY TEST/UP2.jpg"
    },
    {
      id: 10,
      title: "Underground Water Detection",
      description: "Subsurface water mapping and detection",
      videoSrc: `${VIDEO_BASE_PATH}/Underground Water Detector.mp4`,
      thumbnail: "/Testing/PHOTOS (DIFFERENT TESTING) for WEBSITE/WATER PH/380017833_1104104570995829_1152178229961987459_n.jpg"
    }
  ];

  const currentVideo = testingVideos[activeVideo];

  const goToHomeFromLogo = () => {
    setCurrentPage('home');
    setActiveSection('home');
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.querySelector('.mobile-menu')?.classList.remove('active');
  };

  return (
    <div className="testing-page">
      {/* Navigation Bar */}
      <div className="icon-navbar visible">
        <div className="button-container">
          {/* GGC Logo */}
          <button
            type="button"
            className="nav-logo"
            onClick={goToHomeFromLogo}
            aria-label="Go to home"
            title="Home"
          >
            <img 
              src={`${process.env.PUBLIC_URL}/geologo.png`} 
              alt="" 
              className="nav-logo-img"
            />
          </button>
          
          <button 
            className="button"
            onClick={() => {
              setCurrentPage('home');
              setActiveSection('home');
            }}
            title="Home"
          >
            Home
          </button>
          
          <button 
            className="button"
            onClick={() => {
              setCurrentPage('services');
              setActiveSection('services');
            }}
            title="Services"
          >
            Services
          </button>

          <button 
            className="button"
            onClick={() => {
              setCurrentPage('home');
              setTimeout(() => {
                setActiveSection('projects');
                const projectsSection = document.getElementById('projects');
                if (projectsSection) {
                  projectsSection.scrollIntoView({ behavior: 'smooth' });
                }
              }, 120);
            }}
            title="Projects"
          >
            Projects
          </button>

          <button 
            className="button"
            onClick={() => {
              setCurrentPage('home');
              setActiveSection('branches');
            }}
            title="Branches"
          >
            Branches
          </button>

          <button 
            className="button active"
            onClick={() => {
              setCurrentPage('testing');
              setActiveSection('testing');
            }}
            title="Testing"
          >
            Testing
          </button>

          <button
            className="button"
            onClick={() => {
              setCurrentPage('about');
              setActiveSection('about');
              window.scrollTo(0, 0);
            }}
            title="About"
          >
            About
          </button>
        </div>

        {/* Mobile Top Navigation */}
        <div className="mobile-nav-container">
          <button
            type="button"
            className="mobile-logo"
            onClick={goToHomeFromLogo}
            aria-label="Go to home"
            title="Home"
          >
            GEOMATIXS
          </button>
          <button 
            className="mobile-menu-toggle"
            onClick={() => {
              const menu = document.querySelector('.mobile-menu');
              if (menu) {
                menu.classList.toggle('active');
              }
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
            </svg>
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        <div className="mobile-menu">
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('home');
              setActiveSection('home');
              window.scrollTo({ top: 0, behavior: 'smooth' });
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
            <span>Home</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('services');
              setActiveSection('services');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <span>Services</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('home');
              setTimeout(() => {
                setActiveSection('projects');
                const projectsSection = document.getElementById('projects');
                if (projectsSection) {
                  projectsSection.scrollIntoView({ behavior: 'smooth' });
                }
              }, 120);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
            <span>Projects</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={(e) => {
              e.preventDefault();
              if (setCurrentPage !== 'home') {
                setCurrentPage('home');
                setTimeout(() => {
                  setActiveSection('branches');
                  const branchesSection = document.getElementById('branches');
                  if (branchesSection) {
                    branchesSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              } else {
                setActiveSection('branches');
                const branchesSection = document.getElementById('branches');
                if (branchesSection) {
                  branchesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            <span>Branches</span>
          </button>
          <button 
            className="mobile-menu-item active"
            onClick={() => {
              setCurrentPage('testing');
              setActiveSection('testing');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H19V1h-2v1H7V1H5v1H4.5C3.67 2 3 2.67 3 3.5v15C3 19.33 3.67 20 4.5 20h15c.83 0 1.5-.67 1.5-1.5v-15C21 2.67 20.33 2 19.5 2z"/>
            </svg>
            <span>Testing</span>
          </button>
          <button
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('about');
              setActiveSection('about');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
            <span>About</span>
          </button>
        </div>
      </div>

      <div className="container">
        <div className="testing-header">
          <h1>Testing Gallery</h1>
          <p>Explore our in-site testing procedures and capabilities through real project videos</p>
        </div>
        
        <div className="video-section">
          <div className="main-video-player">
            <div className="video-title-bar">
              <h2>{currentVideo.title}</h2>
              <p>{currentVideo.description}</p>
            </div>
            <div className="video-container">
              {videoLoading && !videoError && (
                <div className="video-loading">
                  <div className="loading-spinner"></div>
                  <p>Loading video...</p>
                </div>
              )}
              <video 
                key={currentVideo.videoSrc}
                src={encodeURI(currentVideo.videoSrc)}
                controls
                playsInline
                preload="metadata"
                style={{ width: '100%', height: '100%', display: videoLoading ? 'none' : 'block' }}
                onError={(e) => {
                  console.error('Testing video error:', e.target.error);
                  console.error('Video src:', currentVideo.videoSrc);
                  
                  // Only show fallback for specific error codes that indicate permanent failure
                  const error = e.target.error;
                  if (error && (error.code === 4 || error.code === 3)) {
                    // Error code 4: MEDIA_ERR_SRC_NOT_SUPPORTED
                    // Error code 3: MEDIA_ERR_DECODE
                    e.target.style.display = 'none';
                    const fallback = document.createElement('div');
                    fallback.innerHTML = `
                      <div style="
                        width: 100%; 
                        height: 100%; 
                        background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%); 
                        display: flex; 
                        flex-direction: column; 
                        align-items: center; 
                        justify-content: center; 
                        color: #FFD300; 
                        text-align: center; 
                        padding: 2rem;
                        border: 2px solid #FFD300;
                        border-radius: 8px;
                      ">
                        <h3 style="margin-bottom: 1rem; color: #FFD300;">${currentVideo.title}</h3>
                        <p style="margin-bottom: 1rem; color: #fff;">${currentVideo.description}</p>
                        <p style="color: #ccc; font-size: 0.9rem;">Video temporarily unavailable</p>
                      </div>
                    `;
                    fallback.style.position = 'absolute';
                    fallback.style.top = '0';
                    fallback.style.left = '0';
                    fallback.style.width = '100%';
                    fallback.style.height = '100%';
                    e.target.parentElement.appendChild(fallback);
                  } else {
                    // For other errors (network issues, etc.), try to reload after a delay
                    console.log('Video loading error, attempting retry...');
                    setTimeout(() => {
                      if (e.target && e.target.load) {
                        e.target.load();
                      }
                    }, 2000);
                  }
                }}
                onLoadStart={() => {
                  console.log('Loading video:', currentVideo.videoSrc);
                  setVideoLoading(true);
                  setVideoError(false);
                }}
                onLoadedData={() => {
                  console.log('Video loaded successfully');
                  setVideoLoading(false);
                  setVideoError(false);
                }}
                onCanPlay={() => {
                  setVideoLoading(false);
                  setVideoError(false);
                }}
              >
                Video not supported
              </video>
            </div>
          </div>
          
          <div className="video-playlist">
            <h3>Testing Videos</h3>
            <div className="video-thumbnails">
              {testingVideos.map((video, index) => (
                <div 
                  key={video.id}
                  className={`video-thumbnail ${index === activeVideo ? 'active' : ''}`}
                  onClick={() => {
                    setActiveVideo(index);
                    setVideoLoading(true);
                    setVideoError(false);
                  }}
                >
                  <div className="thumbnail-image">
                    {/* All cards share the same first-frame preview (Compressive Test intro)
                        for a consistent playlist look. `#t=0.1` seeks to the first visible
                        frame after metadata loads. */}
                    <video
                      key={`thumb-${video.id}`}
                      src={`${encodeURI(SHARED_THUMBNAIL_VIDEO_SRC)}#t=0.1`}
                      poster={SHARED_THUMBNAIL_POSTER}
                      muted
                      playsInline
                      preload="metadata"
                      tabIndex={-1}
                      aria-hidden="true"
                      disablePictureInPicture
                      controlsList="nodownload nofullscreen noremoteplayback"
                      onError={(e) => {
                        const el = e.currentTarget;
                        if (el && el.style) el.style.display = 'none';
                        const fallback = el?.parentElement?.querySelector(
                          '.thumbnail-fallback'
                        );
                        if (fallback) fallback.style.display = 'flex';
                      }}
                    />
                    <div className="thumbnail-fallback" style={{ display: 'none' }}>
                      <span>📹</span>
                    </div>
                  </div>
                  <div className="thumbnail-info">
                    <h4>{video.title}</h4>
                    <p>{video.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testing;

